// Central content + brand constants for T'POZ — réseau porté par Plus Belle la Vie 971

export const CONTACT = {
  email: "contact@plusbellelavie971.com",
  phone: "06 90 74 59 10",
  phoneHref: "tel:+590690745910",
  whatsapp: "+590 690 74 59 10",
  whatsappHref: "https://wa.me/590690745910",
  address: "97170 Petit-Bourg, Guadeloupe",
  website: "www.plusbellelavie971.com",
  association: "Plus Belle la Vie 971",
};

export const waLink = (message) =>
  `${CONTACT.whatsappHref}?text=${encodeURIComponent(message)}`;

export const NAV_LINKS = [
  { label: "Accueil", href: "#top" },
  { label: "Le réseau", href: "#parentheses" },
  { label: "Expériences T'POZ", href: "#carte" },
  { label: "Éligibilité", href: "#pour-qui" },
  { label: "Partenaires relais", href: "#reseau" },
];

export const VALUES = [
  "Répit",
  "Pran on ti poz",
  "Ressourcement",
  "Dousman",
  "Bien-être",
  "Sororité",
  "Guadeloupe",
];

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/25bdda54-6b14-4411-bd29-4949ea3c5e07/images/0382bbc4b56a7c8fa69abf97e1b4d53a1b20ec6ad94786a0c4f00b84199b1b14.jpeg",
  constat:
    "https://static.prod-images.emergentagent.com/jobs/25bdda54-6b14-4411-bd29-4949ea3c5e07/images/109f9c6b9883f9c4c420613d808701ea301c299163fbb66ec585de1c3949fb7d.jpeg",
  hebergement:
    "https://static.prod-images.emergentagent.com/jobs/25bdda54-6b14-4411-bd29-4949ea3c5e07/images/26b643e3e2f6deacc71de4f9d8e1e171ec43c16c4783eb163600509bff12759e.jpeg",
  bienEtre:
    "https://static.prod-images.emergentagent.com/jobs/25bdda54-6b14-4411-bd29-4949ea3c5e07/images/8ca5cc57e1c719a391109ee5a3ee8220e43d1bbbb460b7aa064c61e4e79e14a2.jpeg",
  testimonials: [
    "https://static.prod-images.emergentagent.com/jobs/25bdda54-6b14-4411-bd29-4949ea3c5e07/images/4757aaf94799eeccca1d6e795aa2e553767542f3c37cb8ebff0128a4898e2e42.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/25bdda54-6b14-4411-bd29-4949ea3c5e07/images/a17af1c44639493651be134935feeeb5f05c50a59e7404079cae9a569b9b8840.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/25bdda54-6b14-4411-bd29-4949ea3c5e07/images/93e669af8a63e6c9167dea0a9a75b235589b876e5388a29e47bb68bda82cb6af.jpeg",
  ],
};

export const CONSTAT = [
  {
    n: "01",
    title: "Une période de bascule",
    body: "Chaque femme traverse, au cours de sa vie, des périodes de transition qui peuvent être choisies ou subies. À partir de la quarantaine, nombre d'entre elles vivent des changements qui transforment leur quotidien : péri-ménopause ou ménopause, départ des enfants, rôle d'aidante, évolution professionnelle…",
  },
  {
    n: "02",
    title: "Des épreuves qui fragilisent",
    body: "À ces transitions peuvent s'ajouter des épreuves plus lourdes : la maladie, une séparation, un deuil ou une perte d'emploi. Ces situations peuvent entraîner épuisement, isolement et perte de confiance en soi.",
  },
  {
    n: "03",
    title: "Le droit à un temps de répit",
    body: "Nous sommes convaincues qu'un temps de répit, même de courte durée, peut permettre de retrouver un souffle mais aussi les ressources nécessaires pour avancer sereinement.",
  },
];

export const PARENTHESES = [
  {
    key: "hebergement",
    label: "Hébergement",
    title: "Un lieu pour se poser",
    body: "Séjour ou nuitée dans un lieu accueillant, pour ralentir et reprendre des forces. Les séjours peuvent se vivre seule ou en étant accompagnée.",
    points: ["Séjour ou nuitée dans un lieu accueillant", "Cadres apaisants & nature", "Accueil bienveillant"],
  },
  {
    key: "bien-etre",
    label: "Bien-être",
    title: "Une expérience pour se reconnecter",
    body: "Soin ou moment de détente proposé par des professionnels du bien-être : massage, relaxation, yoga doux, respiration ou méditation, activités créatives.",
    points: [
      "Massage ou activité de relaxation",
      "Yoga doux, respiration ou méditation",
      "Activités créatives",
      "Moments de bien-être personnalisés",
    ],
  },
];

export const PARCOURS = [
  {
    n: "1",
    title: "Je découvre les T'POZ",
    body: "Je parcours les temps de répit et de ressourcement, selon ce qui me ferait du bien ou sur la carte.",
  },
  {
    n: "2",
    title: "Je demande mon code",
    body: "Je fais ma demande en quelques minutes. Après validation, je reçois mon code T'POZ par e-mail et par SMS.",
  },
  {
    n: "3",
    title: "Je réserve auprès du partenaire",
    body: "J'appelle le partenaire avec mon code, je choisis ma date et je règle directement chez lui.",
  },
  {
    n: "4",
    title: "Je profite de ma T'POZ",
    body: "Un temps rien que pour moi, à vivre en douceur.",
  },
];

export const FAQ = [
  {
    q: "Qui peut bénéficier de T'POZ ?",
    a: "Les femmes à partir de 40 ans, en Guadeloupe, qui traversent une période de vie exigeante : récupération après une épreuve de santé, isolement, épuisement ou besoin de retrouver leur équilibre. L'éligibilité est vérifiée auprès d'un partenaire relais ou de l'association.",
  },
  {
    q: "Comment faire ma demande ?",
    a: "Choisissez votre T'POZ puis faites votre demande en quelques minutes depuis sa fiche, ou contactez l'association par WhatsApp. Après validation, vous recevez par mail votre code personnel, valable pour 3 T'POZ par an : appelez le partenaire avec votre code, choisissez votre date et réglez directement chez lui.",
  },
  {
    q: "Est-ce un soin médical ou psychologique ?",
    a: "Non. T'POZ propose des temps de répit et de bien-être. Le réseau ne remplace pas un suivi médical ou psychologique : il le complète, en douceur.",
  },
  {
    q: "Dois-je être adhérente ?",
    a: "Non, il n'est pas nécessaire d'être adhérente de l'association pour déposer une demande T'POZ.",
  },
  {
    q: "Puis-je offrir une T'POZ ?",
    a: "Oui. Vous pouvez offrir une T'POZ à une femme qui compte pour vous. Rendez-vous sur la page « Offrir une T'POZ » ou contactez l'association Plus Belle La Vie 971, qui vous accompagnera dans votre démarche.",
  },
  {
    q: "Vous êtes un professionnel ou une structure ?",
    a: (
      <>
        Hébergeur ou professionnel du bien-être ? Proposez une expérience via{" "}
        <a href="#professionnels" className="font-semibold text-[#A66E08] underline underline-offset-2">
          l'espace partenaires
        </a>
        . Association, entreprise ou fondation ? Offrez des T'POZ à une femme ou à un groupe de
        femmes via{" "}
        <a href="#structures" className="font-semibold text-[#A66E08] underline underline-offset-2">
          l'espace structures
        </a>
        .
      </>
    ),
  },
];

export const POUR_QUI = {
  intro:
    "T'POZ s'adresse aux femmes à partir de 40 ans qui traversent une période de vie exigeante et souhaitent s'accorder un temps pour elles.",
  femmes: [
    "Récupération après une épreuve de santé",
    "Période d'isolement",
    "Épuisement ou baisse d'énergie",
    "Besoin de retrouver son équilibre",
  ],
};

export const TESTIMONIALS = [
  {
    quote:
      "J'avais oublié ce que voulait dire prendre soin de moi. Ma T'POZ m'a rendu mon souffle et mon sourire.",
    name: "Marie-Line",
    role: "Bénéficiaire, Basse-Terre",
    videoUrl: null,
  },
  {
    quote:
      "Un week-end de répit qui a tout changé. Je me suis sentie entourée, écoutée, sans avoir à me justifier.",
    name: "Sylvaine",
    role: "Bénéficiaire, Les Abymes",
    videoUrl: null,
  },
  {
    quote:
      "Ouvrir ma maison aux T'POZ, c'est ma façon de rendre ce que la vie m'a donné. Une sororité concrète.",
    name: "Josiane",
    role: "Hébergeuse partenaire",
    videoUrl: null,
  },
];

export const RESEAU = [
  {
    key: "hebergeur",
    anchor: "professionnels",
    title: "Hébergeur ou professionnel du bien-être",
    body: "Vous disposez d'un lieu accueillant ou d'un savoir-faire bien-être ? Proposez une expérience T'POZ.",
    cta: "Je veux proposer une expérience",
    details: [
      "Séjour ou nuitée dans un lieu accueillant",
      "Soins, massages, yoga doux, activités créatives…",
      "Un accompagnement de l'association à chaque étape",
    ],
    subject: "T'POZ — Je veux proposer une expérience",
  },
  {
    key: "relais",
    title: "Organisme ou professionnel relais",
    body: "Vous accompagnez des femmes ? Identifiez, orientez et faites connaître T'POZ autour de vous.",
    cta: "Je veux faire connaître T'POZ",
    details: [
      "Vous identifiez et orientez les femmes éligibles",
      "Vous les aidez à faire leur demande de code T'POZ",
      "Vous ancrez le réseau au plus près des territoires",
    ],
    subject: "T'POZ — Je veux faire connaître le réseau",
  },
  {
    key: "soutien",
    anchor: "structures",
    title: "Association, entreprise ou fondation",
    body: "Agissez pour le répit des femmes.",
    links: [
      { key: "offrir", label: "Offrir des T'POZ", subject: "Offrir des T'POZ" },
      { key: "soutenir", label: "Soutenir l'association", subject: "Soutien financier" },
    ],
    details: [
      "Mécénat, dons ou partenariats solidaires",
      "Un impact concret et local en Guadeloupe",
      "Une visibilité auprès du réseau T'POZ",
    ],
  },
];
